import { useBrokerage as sharedUseBrokerage } from "@fraction/shared-frontend";
import { useAuthUser } from "src/auth/useAuth";
import { useAccountViewPreference } from "src/hooks/useAccountViewPreference";

// Query + updateAssignedBrokerage mutation live in @fraction/shared-frontend; this
// wrapper supplies web's auth/role gating and per-user cache scope. QueryClient-
// level persistence still applies on web.
export function useBrokerage() {
  const { user, isAuthenticated } = useAuthUser();
  const { preference } = useAccountViewPreference();

  return sharedUseBrokerage({
    enabled: preference === "broker" && isAuthenticated,
    userId: user?.id,
  });
}
